import React, { useEffect, useState } from 'react';

import moment from 'moment';

function MeasurementEnvironment(props) {
    const [data_uioption, setData_uioption] = useState({});
    const [data_environment, setData_environment] = useState({})
    const [data_metergrid, setData_metergrid] = useState({})
    const [data_metersolar, setData_metersolar] = useState([])
    const [data_metersolar_total, setData_metersolar_total] = useState({})
    const [data_calculation, setData_calculation] = useState({})

    useEffect(() => {
        return () => {
            setData_uioption({})
            setData_environment({})
            setData_metergrid({})
            setData_metersolar([])
            setData_metersolar_total({})
            setData_calculation({})
        };
    }, []);

    useEffect(() => {
        if (props.data_uioption !== null && props.data_uioption !== undefined) {
            setData_uioption(props.data_uioption)
        }
    }, [props.data_uioption]);

    useEffect(() => {
        if (props.data_environment !== null && props.data_environment !== undefined) {
            setData_environment(props.data_environment)
        }
    }, [props.data_environment]);

    useEffect(() => {
        if (props.data_metergrid !== null && props.data_metergrid !== undefined) {
            setData_metergrid(props.data_metergrid)
        }
    }, [props.data_metergrid]);

    useEffect(() => {
        if (props.data_metersolar !== null && props.data_metersolar !== undefined) {
            setData_metersolar(props.data_metersolar)
        }
    }, [props.data_metersolar]);

    useEffect(() => {
        if (props.data_metersolar_total !== null) {
            if (props.data_metersolar_total !== undefined) {
                setData_metersolar_total(props.data_metersolar_total)
            }
        }
    }, [props.data_metersolar_total]);

    useEffect(() => {
        if (props.data_calculation !== null) {
            setData_calculation(props.data_calculation)
        }
    }, [props.data_calculation]);

    function ReadDatatags(tagobject, tagname, digit, ispercent) {
        if (tagobject !== undefined) {
            if (tagobject !== null) {
                if (tagobject[tagname] !== undefined) {
                    if (ispercent !== undefined) {
                        if (ispercent === true) {
                            if (tagobject[tagname] >= 100) {
                                return "100"
                            }
                        }
                        return tagobject[tagname].toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
                    }
                    return tagobject[tagname].toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
                } else {
                    return "-"
                }
            } else {
                return "-"
            }
        } else {
            return "-"
        }
    }

    function ReadDatatagsPowerProduction(tagobject, tagname, digit) {
        if (tagobject !== null && tagobject !== undefined) {
            if (tagobject["summary_energy"] !== null && tagobject["summary_energy"] !== undefined) {
                if (tagobject["summary_energy"][tagname] !== undefined) {
                    return tagobject["summary_energy"][tagname].toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
                } else {
                    return "-"
                }
            } else {
                return "-"
            }
        } else {
            return "-"
        }
    }

    function ReadDatatagsEnsToday(tagobject, tagname, digit) {
        if (tagobject !== null && tagobject !== undefined) {
            if (tagobject[tagname] !== null && tagobject[tagname] !== undefined) {
                return tagobject[tagname].toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
            } else {
                return "-"
            }
        } else {
            return "-"
        }
    }

    function getDeviceStatusDirect(data) {
        if (data !== undefined) {
            if (data.connection_device !== undefined) {
                if (data.connection_device === true) {
                    return null
                } else {
                    return <span className='tagalarm alarming'>Device Offline</span>
                }
            } else {
                return <span className='tagalarm'>...</span>
            }
        } else {
            return <span className='tagalarm'>...</span>
        }
    }

    function getDeviceStatus(data) {
        if (data !== undefined) {
            if (data.connection_logger !== undefined) {
                if (data.connection_logger === true) {
                    if (data.connection_device === true) {
                        return null
                    } else {
                        return <span className='tagalarm alarming'>Device Offline</span>
                    }
                } else {
                    return <span className='tagalarm alarming'>Logger Offline</span>
                }
            } else {
                return <span className='tagalarm'>...</span>
            }
        } else {
            return <span className='tagalarm'>...</span>
        }
    }

    function getIRRErrorStatus(data) {
        if (data !== undefined) {
            if (data.irr_error_lock !== undefined) {
                if (data.irr_error_lock === false) {
                    return null
                } else {
                    return <span className='tagalarm alarming'>Error</span>
                }
            } else {
                return <span className='tagalarm'>...</span>
            }
        } else {
            return <span className='tagalarm'>...</span>
        }
    }

    function getIRRError_Color(data) {
        if (data !== undefined) {
            if (data.irr_error_lock !== undefined) {
                if (data.irr_error_lock === false) {
                    return "color-green"
                } else {
                    return "color-red"
                }
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    function getTagString(data, tag) {
        if (data !== undefined) {
            if (data[tag] !== undefined) {
                return data[tag]
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    function getPR30DBlock(data) {
        if (data !== undefined) {
            if (data.pr30d !== undefined) {
                return <div className="measure-side-rows">
                    <div className="measure-side-cell">% PR 30D</div>
                    <div className="measure-side-cell font-right font-sarabun px-4 fw-600 fw-20px ">{ReadDatatags(data_calculation, 'pr30d', 2, true)}</div>
                </div>
            } else {
                return null
            }
        } else {
            return null
        }
    }

    function getSamplingState(tagobject, tagname, index) {
        if (tagobject !== undefined) {
            if (tagobject !== null) {
                if (tagobject[tagname] !== undefined) {
                    if (tagobject[tagname][index].state === 1) {
                        return "alarmevent-bg-green"
                    } else if (tagobject[tagname][index].state === 2) {
                        return "alarmevent-bg-red"
                    } else if (tagobject[tagname][index].state === 3) {
                        return "alarmevent-bg-orange"
                    } else {
                        return ""
                    }
                } else {
                    return ""
                }
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    function ReadTags_SensorAlert(data, con_tag, alert_tag) {
        if (data !== undefined) {
            if (data[alert_tag] !== undefined) {
                if (data[con_tag] !== undefined) {
                    if (data.connection_logger === true && data.connection_device === true) {
                        if (data[con_tag]["connection_logger"] === true && data[con_tag]["connection_device"] === true) {
                            if (data[alert_tag] === true) {
                                return " alarmevent-text-red"
                            } else {
                                return ""
                            }
                        } else {
                            return " alarmevent-text-red"
                        }
                    } else {
                        return " alarmevent-text-red"
                    }
                } else {
                    return ""
                }
            } else {
                return ""
            }
        } else {
            return ""
        }
    }

    function get_panel_area() {
        if (data_uioption !== null && data_uioption !== undefined) {
            if (data_uioption.factor_area !== null && data_uioption.factor_area !== undefined) {
                return data_uioption.factor_area.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
        }
        return "-"
    }

    function get_site_capacity() {
        if (data_uioption !== null && data_uioption !== undefined) {
            if (data_uioption.capacity !== null && data_uioption.capacity !== undefined) {
                return data_uioption.capacity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
        }
        return "-"
    }

    function draw_solar_meter_total(meter_solar, meter_solar_total) {
        if (meter_solar !== null) {
            if (meter_solar !== undefined) {
                if (meter_solar.length > 1) {
                    if (meter_solar_total !== undefined) {
                        return <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12" key={'MeterSolar-' + meter_solar_total.meter_id_text}>
                            <div>
                                <hr className="mt-1 mb-2" />
                                <h6 className="mb-0">{meter_solar_total.meter_id_text} {meter_solar_total.connection_device === false ? <span className='tagalarm alarming'>Device Offline</span> : null}</h6>
                                <div className="measure-side-table">
                                    <div className="measure-side-rows">
                                        <div className="measure-side-cell">P</div>
                                        <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter_solar_total, 'power_active_total', 2)}</div>
                                        <div className="measure-side-cell measure-side-cell-unit">kW</div>
                                    </div>
                                    <div className="measure-side-rows">
                                        <div className="measure-side-cell">S</div>
                                        <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter_solar_total, 'power_apparent_total', 2)}</div>
                                        <div className="measure-side-cell measure-side-cell-unit">kVA</div>
                                    </div>
                                    <div className="measure-side-rows">
                                        <div className="measure-side-cell">V</div>
                                        <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter_solar_total, 'voltage', 2)}</div>
                                        <div className="measure-side-cell measure-side-cell-unit">V</div>
                                    </div>
                                    <div className="measure-side-rows">
                                        <div className="measure-side-cell">I</div>
                                        <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter_solar_total, 'current_total', 2)}</div>
                                        <div className="measure-side-cell measure-side-cell-unit">A</div>
                                    </div>
                                    <div className="measure-side-rows">
                                        <div className="measure-side-cell">PF</div>
                                        <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter_solar_total, 'power_factor', 2)}</div>
                                        <div className="measure-side-cell measure-side-cell-unit"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                }
            }
        }
        return null
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2  d-md-none">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-weather-partly-cloudy color-orange"></i> Environment</h4>
                                    <p className="mb-1">Environment monitoring</p>
                                    <h6 className='mb-0'><i className="mdi mdi-clock-time-four-outline"></i> Update : {props.server_update !== "-" ? moment(new Date(props.server_update)).format("YYYY-MM-DD HH:mm:ss") : "Unknown"}</h6>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="row">
                        <aside className="w-md-250px content__wrap flex-shrink-0 pe-0 order-1 border-right d-md-none">
                            <div className='d-flex justify-content-between pe-2 align-middle'>
                                <h4>Capacity</h4>
                                <h4>{get_site_capacity()} kWp</h4>
                            </div>
                            <div className='d-flex justify-content-between pe-2 align-middle'>
                                <h6>Total Panel Area {get_panel_area()} m<sup>2</sup></h6>
                            </div>

                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                                    <hr className="mt-1 mb-2" />
                                    <h5 className="mb-0"><i className="fas fa-bolt mb-2 me-1 fs-5 color-green" style={{ minWidth: "2px" }}></i> Production Summary</h5>
                                    <div className="measure-side-table production">
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">Today</div>
                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatagsPowerProduction(data_calculation, 'today', 3)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">kWh</div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">This Month</div>
                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatagsPowerProduction(data_calculation, 'thismonth', 3)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">MWh</div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">This Year</div>
                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatagsPowerProduction(data_calculation, 'thisyear', 3)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">MWh</div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">Total</div>
                                            <div className="measure-side-cell font-right font-sarabun px-2 color-green fw-600">{ReadDatatagsPowerProduction(data_calculation, 'total', 3)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">MWh</div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">ENS Today</div>
                                            <div className={"measure-side-cell font-right font-sarabun px-2 fw-600 " + getIRRError_Color(data_calculation)}>{ReadDatatagsEnsToday(data_calculation, 'ens_today_raw', 3)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">kWh</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                                    <hr className="mt-1 mb-2" />
                                    <h5 className="mb-0">System Ratio {getIRRErrorStatus(data_calculation)}</h5>
                                    <div className="measure-side-table">
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">% OR</div>
                                            <div className={"measure-side-cell font-right font-sarabun px-4 fw-600 fw-20px " + getIRRError_Color(data_calculation)}>{ReadDatatags(data_calculation, 'operation_ratio', 2, true)}</div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">% PR</div>
                                            <div className={"measure-side-cell font-right font-sarabun px-4 fw-600 fw-20px " + getIRRError_Color(data_calculation)}>{ReadDatatags(data_calculation, 'performance_ratio', 2, true)}</div>
                                        </div>
                                        {
                                            getPR30DBlock(data_calculation)
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                                    <hr className="mt-1 mb-2" />
                                    <h6 className="mb-0">Environment {getDeviceStatus(data_environment)}</h6>
                                    <div className='env-sampling-indicator' >
                                        <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 0))}></div>
                                        <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 1))}></div>
                                        <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 2))}></div>
                                        <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 3))}></div>
                                        <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 4))}></div>
                                        <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 5))}></div>
                                        <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 6))}></div>
                                        <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 7))}></div>
                                        <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 8))}></div>
                                        <div className={'env-sampling-item ' + (getSamplingState(data_environment, 'irr_sampling', 9))}></div>
                                    </div>
                                    <div className="measure-side-table">
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell"><i className="mdi mdi-weather-sunny mb-2 me-1 fs-5 color-orange" style={{ minWidth: "2px" }}></i> {getTagString(data_environment, 'irr1_name')}</div>
                                            <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_irr1", 'sensor_alert_irr1')}>{ReadDatatags(data_environment, 'total_irr1', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                        {
                                            data_uioption.has_irr2 ?
                                                data_uioption.has_irr2 === true ?
                                                    <div className="measure-side-rows">
                                                        <div className="measure-side-cell"><i className="mdi mdi-weather-sunny mb-2 me-1 fs-5 color-orange" style={{ minWidth: "2px" }}></i> {getTagString(data_environment, 'irr2_name')}</div>
                                                        <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_irr2", 'sensor_alert_irr2')}>{ReadDatatags(data_environment, 'total_irr2', 2)}</div>
                                                        <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                                    </div>
                                                    :
                                                    null
                                                :
                                                null
                                        }
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell"><i className="mdi mdi-weather-sunny mb-2 me-1 fs-5 color-orange" style={{ minWidth: "2px" }}></i> IRR AVG.</div>
                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(data_environment, 'irr_avg_total', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">W/m<sup>2</sup></div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell"><i className="mdi mdi-thermometer mb-2 me-1 fs-5 color-green" style={{ minWidth: "2px" }}></i> Amb. Temp.</div>
                                            <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_ambient_rh", 'sensor_alert_temp_ambient')}>{ReadDatatags(data_environment, 'ambient_temp', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">°C</div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell"><i className="mdi mdi-thermometer-lines mb-2 me-1 fs-5 color-green" style={{ minWidth: "2px" }}></i> Panel Temp.</div>
                                            <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_temp_pv", 'sensor_alert_temp_pv')}>{ReadDatatags(data_environment, 'pv_temp', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">°C</div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell"><i className="mdi mdi-thermometer-lines mb-2 me-1 fs-5 color-green" style={{ minWidth: "2px" }}></i> Tray Temp.</div>
                                            <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_temp_tray", 'sensor_alert_temp_tray')}>{ReadDatatags(data_environment, 'custom1_tempraceway', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">°C</div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell"><i className="mdi mdi-thermometer-lines mb-2 me-1 fs-5 color-sky" style={{ minWidth: "2px" }}></i> R.Humidity</div>
                                            <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_ambient_rh", 'sensor_alert_humidity')}>{ReadDatatags(data_environment, 'custom2_rh', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">%RH</div>
                                        </div>
                                        {
                                            data_uioption.has_windspeed ?
                                                data_uioption.has_windspeed === true ?
                                                    <>
                                                        <div className="measure-side-rows">
                                                            <div className="measure-side-cell"><i className="mdi mdi-windsock mb-2 me-1 fs-5 color-sky" style={{ minWidth: "2px" }}></i> Wind Speed</div>
                                                            <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_windsensor", 'sensor_alert_wind_speed')}>{ReadDatatags(data_environment, 'windspeed', 2)}</div>
                                                            <div className="measure-side-cell measure-side-cell-unit">m/sec.</div>
                                                        </div>
                                                        <div className="measure-side-rows">
                                                            <div className="measure-side-cell"><i className="mdi mdi-compass mb-2 me-1 fs-5 color-sky" style={{ minWidth: "2px" }}></i> Wind Direction</div>
                                                            <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_windsensor", 'sensor_alert_wind_direction')}>{ReadDatatags(data_environment, 'winddirection', 0)}</div>
                                                            <div className="measure-side-cell measure-side-cell-unit">°</div>
                                                        </div>
                                                    </>
                                                    :
                                                    null
                                                :
                                                null
                                        }
                                        {
                                            data_uioption.has_waterlevel ?
                                                data_uioption.has_waterlevel === true ?
                                                    <div className="measure-side-rows">
                                                        <div className="measure-side-cell"><i className="mdi mdi-waves mb-2 me-1 fs-5 color-sky" style={{ minWidth: "2px" }}></i> Water Level</div>
                                                        <div className={"measure-side-cell font-right font-sarabun px-2 fw-600" + ReadTags_SensorAlert(data_environment, "connection_waterlevel", 'sensor_alert_water_level')}>{ReadDatatags(data_environment, 'waterlevel', 2)}</div>
                                                        <div className="measure-side-cell measure-side-cell-unit">m.</div>
                                                    </div>
                                                    :
                                                    null
                                                :
                                                null
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                                    <hr className="mt-1 mb-2" />
                                    <h6 className="mb-0">Grid Meter {getDeviceStatus(data_metergrid)}</h6>
                                    {
                                        data_metergrid ?
                                            <h6 className="mb-0 h6">S/N: {data_metergrid.serial_no}</h6>
                                            :
                                            <h6 className="mb-0 h6">S/N: -</h6>
                                    }
                                    <div className="measure-side-table">
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">P</div>
                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(data_metergrid, 'power_active_total', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">kW</div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">S</div>
                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(data_metergrid, 'power_apparent_total', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">kVA</div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">V</div>
                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(data_metergrid, 'voltage_l1', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">V</div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">I</div>
                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(data_metergrid, 'current_total', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit">A</div>
                                        </div>
                                        <div className="measure-side-rows">
                                            <div className="measure-side-cell">PF</div>
                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(data_metergrid, 'power_factor', 2)}</div>
                                            <div className="measure-side-cell measure-side-cell-unit"></div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    draw_solar_meter_total(data_metersolar, data_metersolar_total)
                                }
                                {
                                    data_metersolar ?
                                        data_metersolar.map((meter, index) => (
                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12" key={'MeterSolar-' + meter.meter_id}>
                                                <div>
                                                    <hr className="mt-1 mb-2" />
                                                    <h6 className="mb-0">{meter.meter_id_text} {getDeviceStatusDirect(meter)}</h6>
                                                    <h6 className="mb-0 h6">{meter.meter_area_name}</h6>
                                                    <h6 className="mb-0 h6">S/N: {meter.serial_no}</h6>
                                                    <div className="measure-side-table">
                                                        <div className="measure-side-rows">
                                                            <div className="measure-side-cell">P</div>
                                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter, 'power_active_total', 2)}</div>
                                                            <div className="measure-side-cell measure-side-cell-unit">kW</div>
                                                        </div>
                                                        <div className="measure-side-rows">
                                                            <div className="measure-side-cell">S</div>
                                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter, 'power_apparent_total', 2)}</div>
                                                            <div className="measure-side-cell measure-side-cell-unit">kVA</div>
                                                        </div>
                                                        <div className="measure-side-rows">
                                                            <div className="measure-side-cell">V</div>
                                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter, 'voltage_l1', 2)}</div>
                                                            <div className="measure-side-cell measure-side-cell-unit">V</div>
                                                        </div>
                                                        <div className="measure-side-rows">
                                                            <div className="measure-side-cell">I</div>
                                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter, 'current_total', 2)}</div>
                                                            <div className="measure-side-cell measure-side-cell-unit">A</div>
                                                        </div>
                                                        <div className="measure-side-rows">
                                                            <div className="measure-side-cell">PF</div>
                                                            <div className="measure-side-cell font-right font-sarabun px-2 fw-600">{ReadDatatags(meter, 'power_factor', 2)}</div>
                                                            <div className="measure-side-cell measure-side-cell-unit"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                        :
                                        null
                                }
                            </div>
                        </aside>

                    </div>

                </div>
            </div>
        </div>
    )
}
export default MeasurementEnvironment